module.exports = __webpack_public_path__ + "img/logo-torbel-white.438a5997.svg";